import PageCompiler from '@edools/page-compiler'
import Landing from '@/services/Landing.js'
import UPDATE from '@/store/landing/actions/update'
import INSERT from '@/store/landing/actions/insert'
import REMOVE from '@/store/landing/actions/remove'
import FORM from '@/store/landing/actions/form'
import DUPLICATE from '@/store/landing/actions/duplicate'
import BATCH from '@/store/landing/actions/batch'
import TENANT from '@/store/landing/actions/tenant'

const { mergeWithDefaultProps } = PageCompiler

export default {
  setPageCategory({ commit }, pageCategory) {
    commit('setPageCategory', pageCategory)
  },
  setPageType({ commit }, pageType) {
    commit('setPageType', pageType)
  },
  setLanding({ commit }, landing) {
    const mixedLanding = mergeWithDefaultProps(landing)
    commit('setLanding', mixedLanding)
  },
  async saveName({ commit }, params) {
    const response = await Landing.setDynamicLanding(params)
    const { name } = response.data.data.savePage
    commit('setName', name)
  },
  setName({ commit }, name) {
    commit('setName', name)
  },
  setPublish({ commit }, published) {
    commit('setPublish', published)
  },
  async saveTitle({ commit }, params) {
    const response = await Landing.setDynamicLanding(params)
    const { title } = response.data.data.savePage
    commit('setTitle', title)
  },
  setTitle({ commit }, title) {
    commit('setTitle', title)
  },
  setActive({ commit }, activeId = '') {
    commit('setActive', activeId)
  },
  setCurrentView({ commit }, view) {
    commit('setCurrentView', view)
  },
  setCurrentNavBar({ commit }, navBar) {
    commit('setCurrentNavBar', navBar)
  },

  ...INSERT,
  ...UPDATE,
  ...REMOVE,
  ...FORM,
  ...DUPLICATE,
  ...BATCH,
  ...TENANT,
}
